// extracted by mini-css-extract-plugin
export var calendarView = "_jg-0";